import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  typography: {
    fontFamily: ['Pretendard', 'PretendardJP', 'NotoSansCJK'],
    ellipsis: {
      display: 'block',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    },
  },
  palette: {
    primary: { main: '#773DBD' }, // #773DBD
    secondary: { main: '#1E293B' }, // #1E293B
    third: { main: '#fff' }, // #fff
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          fontFamily: 'Pretendard',
          '& .MuiInputBase-input::placeholder': {
            color: '#A9B6CA',
            opacity: 1,
            fontFamily: 'Pretendard',
          },
          '& fieldset': {
            borderColor: '#E2E8EF', // 기본 보더 색
          },
          '&:hover fieldset': {
            borderColor: '#00B19D', // 호버 시 보더 색
          },
          '&.Mui-focused fieldset': {
            borderColor: '#773DBD', // 포커스 시 보더 색
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          fontFamily: 'Pretendard',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#E2E8EF', // 기본 보더 색
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            // borderColor: '#00B19D', // 호버 시 보더 색
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#773DBD', // 포커스 시 보더 색
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          fontFamily: 'Pretendard',
          '& .MuiInputBase-input': {
            fontFamily: 'Pretendard',
          },
          '& .MuiOutlinedInput-input': {
            fontFamily: 'Pretendard',
          },
          '& .MuiInputBase-input::placeholder': {
            color: '#A9B6CA',
            opacity: 1,
            fontFamily: 'Pretendard',
          },
        },
      },
      variants: [
        {
          props: { variant: 'primary' },
          style: {
            '& .MuiInputBase-root': {
              borderRadius: '5px',
              fontFamily: 'Pretendard',
            },
          },
        },
        {
          props: { variant: 'filled' },
          style: {
            '& .MuiFilledInput-root': {
              borderRadius: '5px',
              fontFamily: 'Pretendard',
              border: 0,
              backgroundColor: '#FAFAFA',
              '&:hover': {
                backgroundColor: '#FAFAFA',
              },
              '&.Mui-focused': {
                backgroundColor: '#FAFAFA',
              },
            },
            '& .MuiFilledInput-underline': {
              '&:before': {
                borderBottom: 'none',
              },
            },
          },
        },
      ],
    },
    MuiButton: {
      styleOverrides: {
        root: {
          padding: '1px 10px 1px',
          minWidth: 0,
          display: 'flex',
          fontFamily: 'Pretendard',
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: '2px',
          boxShadow: 'none',
          textTransform: 'initial',
          color: '#0AAAED',
          'MuiButton-contained': {
            textTransform: 'lowercase',
          },
        },
      },
      variants: [
        {
          props: { variant: 'contained' },
          style: {
            color: '#fff',
            background: '#773DBD',
            border: '1px solid #773DBD',
            height: '38px',
            '&:hover': {
              background: '#773DBD',
              borderColor: '#773DBD',
              boxShadow: 'none',
            },
            '&:disabled': {
              border: '1px solid #c9b2e6',
              backgroundColor: '#c9b2e6',
              color: '#fff',
            },
          },
        },
        {
          props: { variant: 'outlined' },
          style: {
            color: '#0AAAED',
            background: '#fff',
            border: '1px solid #0AAAED',
            height: '38px',
            '&:hover': {
              border: '1px solid #0AAAED',
              background: '#fff',
              boxShadow: 'none',
            },
            '&:disabled': {
              backgroundColor: '#fff',
              borderColor: '#0AAAED',
              color: '#0AAAED',
              opacity: 0.5,
            },
          },
        },
        {
          props: { variant: 'dark' },
          style: {
            color: '#fff',
            background: '#1E293B',
            border: 'none',
            height: '38px',
            '&:hover': {
              border: 'none',
              background: '#1E293B',
            },
            '&:disabled': {
              backgroundColor: 'lightgray',
              color: '#fff',
            },
          },
        },
        {
          props: { variant: 'darklined' },
          style: {
            color: '#1E293B',
            background: '#fff',
            border: '1px solid #1E293B',
            height: '38px',
            '&:disabled': {
              backgroundColor: 'lightgray',
              color: '#fff',
              border: 'none',
            },
          },
        },
        {
          props: { variant: 'gray' },
          style: {
            color: '#1E293B',
            background: '#CBD5E1',
            border: 'none',
            height: '38px',
            '&:hover': {
              border: 'none',
              // background: '#A9B6CA',
            },
            '&:disabled': {
              backgroundColor: 'rgba(203, 213, 225, .5)',
              color: '#fff',
            },
          },
        },
        {
          props: { variant: 'graylined' },
          style: {
            color: '#1E293B',
            background: '#fff',
            border: '1px solid #CBD5E1',
            height: '38px',
            '&:hover': {
              background: '#fff',
              border: '1px solid #CBD5E1',
            },
            '&:disabled': {
              color: 'lightgray',
              background: '#fff',
              border: '1px solid #CBD5E1',
            },
          },
        },
      ],
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          fontFamily: 'Pretendard, sans-serif', // ✅ FormControlLabel 폰트 적용
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontFamily: 'Pretendard',
        },
        input: {
          fontFamily: 'Pretendard',
        },
      },
    },
  },
  breakpoints: {
    values: {
      mobile: 0,
      sm: 600,
      desktop: 1090, // 640 이상이면 데탑으로 본다
    },
  },
});
